/**
 * Utah's words for journey.ts: the Utah rules and research rows behind the personal path's permit, plan review, manager
 * certificate, team and opening-checks items. Data only.
 */
export const JOURNEY_UT = {
  /** The state rule that adopts the Food Code (cited next to Food Code sections in the path items' sources). */
  foodCodeRule: "R392-100",
  /** The saved research page behind "See your path to a permit" (how a business gets set up and permitted). */
  permitResearchDoc: "docs/source/research/business-setup-utah.md",
  /** The food truck rule on plan review (cited for "Call your county about plan review"). */
  truckPlanReviewRule: "R392-102-5",
  /** Who must hold a food safety manager certificate (the "why" line of the manager item): Utah requires a certified manager at a food business. */
  managerWhy: "Utah needs a certified food safety manager at your food business, so start before opening day is close.",
  /** The statute sections for the manager certificate. */
  managerSource: "Utah Code 26B-7-410, 26B-7-412",
  /** The statute section that gives each food worker their own permit (the "add your team" item). */
  handlerPermitSource: "Utah Code 26B-7-413 (each food worker's own permit)",
} as const;
